import Accordion from "@/components/Accordion";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import { Toggle } from "@/components/Toggle";
import React from "react";
import TextInput from "../../TextInput";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function BookAppointment(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item
      eventKey="book-appointment"
      onExpanded={() => props.onExpanded()}
    >
      <Accordion.Header>
        <Accordion.Title>Calendly</Accordion.Title>
        <Accordion.SubTitle>
          Let your customer schedule meetings through the chat window
        </Accordion.SubTitle>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="flex justify-between items-center">
            <div className="text-sm font-medium">Enable</div>
            <Toggle
              toggled={workingLanguageConfig.calendlyEnabled}
              changeToggle={() =>
                updateLanguageConfig({
                  calendlyEnabled: !workingLanguageConfig.calendlyEnabled
                })
              }
            />
          </div>
          <div className="my-3 border-t border-slate-200" />
          <div className="text-sm font-medium">Title</div>
          <TextInput
            value={workingLanguageConfig.calendlyTitle}
            setValue={(value) => updateLanguageConfig({ calendlyTitle: value })}
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">Message</div>
          <TextInput
            value={workingLanguageConfig.calendlySubTitle}
            setValue={(value) =>
              updateLanguageConfig({ calendlySubTitle: value })
            }
            showEmojiButton={false}
          />
          <div className="text-sm font-medium my-2">URL</div>
          <TextInput
            value={workingLanguageConfig.calendlyUrl}
            setValue={(value) => updateLanguageConfig({ calendlyUrl: value })}
            showEmojiButton={false}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
